module.exports = __webpack_public_path__ + "static/media/ucon2.302c4e0a.JPG";